if (!customElements.get('menu-tabs')) {
  customElements.define(
    'menu-tabs',
    class MenuTabs extends HTMLElement {
      constructor() {
        super();

        this.buttonTabs = this.querySelectorAll('.tab-buttons .button-tab');
        this.tabContents = this.querySelectorAll('.tab-content');

        this.activeContentTab = this.activeContentTab.bind(this);
        this.iniSlider = this.iniSlider.bind(this);

        if (window.matchMedia("(max-width: 989px)").matches) {
          this.iniSlider(this.tabContents);
        }

        window.addEventListener('resize', () => {
          if (window.matchMedia("(max-width: 989px)").matches) {
            this.iniSlider(this.tabContents);
          }
        });

      }

      connectedCallback() {
        this.buttonTabs.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();

            const targetTab = button.getAttribute('data-target');
            this.activeContentTab(targetTab);

            // Initialize the slider on mobile device
            if (window.matchMedia("(max-width: 989px)").matches) {
              setTimeout(() => {
                this.iniSlider(this.tabContents);
              }, 150)
            }
          });
        });
      }

      activeContentTab(targetTab) {

        this.tabContents.forEach((content) => {
          let tabTarget = 'tab-' + targetTab;

          if (content.id === tabTarget) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });

        this.buttonTabs.forEach((button) => {
          if (button.getAttribute('data-target') === targetTab) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
      }

      iniSlider(tabContents) {
        document.addEventListener('DOMContentLoaded', () => {
          if (window.matchMedia("(max-width: 989px)").matches) {
            tabContents.forEach((itemSlide, index) => {
          
              const idSlider = `Slider-${itemSlide.getAttribute('data-id')}`;
              // Initialize using the element directly; add observers so it reflows when shown
              // eslint-disable-next-line no-undef
              let swiper = new Swiper(`#${idSlider}`, {
                slidesPerView: 1.5,
                spaceBetween: 8,
                centeredSlides: false,
                observer: true,
                observeParents: true,
                breakpoints: {
                  320: {
                    slidesPerView: 1.5,
                    spaceBetween: 8,
                    loop: true,
                  },
                  568: {
                    slidesPerView: 2.5,
                    spaceBetween: 8,
                    centeredSlides: false
                  },
                  768: {
                    slidesPerView: 3.5,
                    spaceBetween: 16,
                    centeredSlides: false
                  },
                }
              });

              swiper[index] = swiper;
              console.log(swiper);
              //swiper.update();
            })
          }else {

            // If not mobile, remove swiper instance if exists
            this.tabContents.forEach((content) => {
              const idSlider = `Slider-${content.getAttribute('data-id')}`;
              const containerEl = document.getElementById(idSlider);
              if (containerEl && containerEl.swiper) {
                containerEl.swiper.destroy(true, true);
              }
            });
          }
        })
      }
    }
  );
}

if (!customElements.get('menu-dropdown-mobile')) {
  customElements.define(
    'menu-dropdown-mobile',
    class MenuTabsMobile extends HTMLElement {
      constructor() {
        super();

        this.linkTabs = this.querySelectorAll('.menu-drawer__menu-item');
        this.wrapContentTabs = this.querySelectorAll('.mobile__content-tab');

        this.activeContentTab = this.activeContentTab.bind(this);
      }

      connectedCallback() {
        this.linkTabs.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();

            const targetTab = link.getAttribute('data-menu-tab');
            if(event.target.classList.contains('active')) {
              this.remoActiveContentTab(targetTab);
            }else{
              this.activeContentTab(targetTab);
            }
          });
        });
      }

      activeContentTab(targetTab) {
        this.wrapContentTabs.forEach((content) => {
          let tabTarget = content.getAttribute('data-tab-content');

          if (tabTarget === targetTab) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });

        this.linkTabs.forEach((link) => {
          if (link.getAttribute('data-menu-tab') === targetTab) {
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        });
      }
      
      remoActiveContentTab(targetTab) {
        this.wrapContentTabs.forEach((content) => {
          let tabTarget = content.getAttribute('data-tab-content');

          if (tabTarget === targetTab) {
            content.classList.remove('active');
          }
        });

        this.linkTabs.forEach((link) => {
          if (link.getAttribute('data-menu-tab') === targetTab) {
            link.classList.remove('active');
          }
        });
      }

    }
  );
}